'use client';

import { useAuth } from '@/contexts/AuthContext';
import Link from 'next/link';
import { Plus } from 'lucide-react';

export function ChangelogAdminBar() {
  const { isSuperAdmin, loading } = useAuth();

  if (loading || !isSuperAdmin) {
    return null;
  }

  return (
    <div className="bg-blue-50 dark:bg-blue-950 border-b border-blue-200 dark:border-blue-800 px-6 py-3">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-blue-700 dark:text-blue-300">
            📝 Admin Mode
          </span>
        </div>
        <Link
          href="/admin/changelog"
          className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded transition-colors"
        >
          <Plus className="w-4 h-4" />
          New Post
        </Link>
      </div>
    </div>
  );
}
